import { render, staticRenderFns } from "./TeamProfessionDropdown.vue?vue&type=template&id=25df2fe6&scoped=true&"
import script from "./TeamProfessionDropdown.vue?vue&type=script&lang=js&"
export * from "./TeamProfessionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df2fe6",
  null
  
)

export default component.exports